module.exports = __webpack_public_path__ + "static/media/user.30750645.svg";